var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('router-link',{staticClass:"guide",attrs:{"tag":"a","to":_vm.href}},[_c('div',{staticClass:"guide-img"},[_vm._t("default")],2),_c('h5',[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"description",domProps:{"innerHTML":_vm._s(_vm.description)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }